module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAiCAMAAADvReCJAAAAS1BMVEUAAAD0zovyz4jzzoj/1ZXzz4nzz4jzz4n41pHyz4nzz4nzz4jz0Inzz4nzz4j0z4n00Yn11o/////yzojzzoj0zorzz4r00ojyzoiltLfVAAAAGHRSTlMARKHhDPvs0RLLmJFr6MBFNxkC8b1ZVS16r14dAAAAhUlEQVQ4y93QSQ6EIBRF0YtKj2117H+l5awMRPlDU3fyJieEfMBFr/NZ2kcHMJt8nZlh3VGLrYTcLmAFyqIFSpMl/Ynq1aD6ciulAFVupQZgKFf2luxfN7jXvdRDpJ4ilSRq2gSqcxyV7+pCWuCg7MJJP2XSRkvp6Lhs3NH0odFrtG9afQG+3VypAQOw6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FLVersion/fl_wer.png
// module id = zUW4
// module chunks = 0